import React, { useContext } from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'
import { GlobalContext } from 'core/contexts/global-context'

const PostGallery = props => {
  const { items } = props
  const { screenWidth } = useContext(GlobalContext)

  return (
    <ul className="post-gallery">
      {items.map(item => {
        const featuredImg =
          screenWidth < 1000 ? item.featured_image['feature-md'] : item.featured_image['feature-lg']

        const poster = (
          <div
            className="post-gallery-poster"
            style={{ backgroundImage: featuredImg ? `url(${featuredImg[0]})` : null }}
          >
            <h2 className="post-gallery-title type-heading mod-md-head">{item.post_title}</h2>
          </div>
        )

        const labels = (
          <div className="post-gallery-labels">
            {item.terms.project_type && (
              <p className="post-gallery-type type-body mod-md-body">
                {item.terms.project_type[0].name}
              </p>
            )}
            {item.terms.project_location && (
              <p className="post-gallery-location type-body mod-md-body">
                {item.terms.project_location[0].name}
              </p>
            )}
          </div>
        )

        return (
          <li key={item.ID} className="post-gallery-item">
            {item.fields.redirect_url ? (
              <a href={item.fields.redirect_url} target="_blank" className="post-gallery-link">
                {poster}
                {labels}
              </a>
            ) : (
              <Link to={`/project/${item.post_name}`} className="post-gallery-link">
                {poster}
                {labels}
              </Link>
            )}
          </li>
        )
      })}
    </ul>
  )
}

PostGallery.propTypes = {
  items: PropTypes.array.isRequired
}

export default PostGallery
